// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as OrderCommentsApiModel from "../api-model/OrderCommentsApiModel.bs.js";

function execute(json) {
  var comments = DeccoUtils$Catalyst.resolveResult(OrderCommentsApiModel.t_decode(json), "OrderCommentsEntityMapper.re");
  return List.map((function (c) {
                return {
                        created_at: Timestamp$Catalyst.make(c.timestamp),
                        commenter: c.admin_name,
                        comment: c.comment
                      };
              }), List.sort((function (c1, c2) {
                    return (c1.timestamp | 0) - (c2.timestamp | 0) | 0;
                  }), comments.comments));
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
